(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    const contactStartedAt = new WeakMap();

  document.addEventListener('focusin', (event) => {
    const form = event.target.closest('.contact-form__form');
    if (form && !contactStartedAt.has(form)) contactStartedAt.set(form, Date.now());
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-contact-challenge]')) event.target.setCustomValidity('');
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('.contact-form__form');
      if (!form) return;

      const trap = form.querySelector('[data-contact-website]');
      const challenge = form.querySelector('[data-contact-challenge]');
      const startedAt = contactStartedAt.get(form);
      const looksAutomated = trap.value.trim() !== '' || !startedAt || Date.now() - startedAt < 3000;

      if (looksAutomated || challenge.value.trim() !== '7') {
        event.preventDefault();
        challenge.setCustomValidity(challenge.dataset.error);
        challenge.reportValidity();
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
